import { render, staticRenderFns } from "./AdminPanelEducation.vue?vue&type=template&id=6d62064f&scoped=true"
import script from "./AdminPanelEducation.vue?vue&type=script&lang=js"
export * from "./AdminPanelEducation.vue?vue&type=script&lang=js"
import style0 from "./AdminPanelEducation.vue?vue&type=style&index=0&id=6d62064f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d62064f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
